import axios from 'axios'
import { urlApi } from '@/config/global'

async function createUploadUrl({ destino, fileName, contentType, size, idProcesso, idProcessoModeloArtefato, dsHash }) {
    const endpoint = dsHash
        ? `${urlApi}/Utilidade/UploadUrlPublico`
        : `${urlApi}/Utilidade/UploadUrl`

    try {
        const { data } = await axios.post(endpoint, {
            destino,
            fileName,
            contentType: contentType || 'application/octet-stream',
            size,
            idProcesso: idProcesso || null,
            idProcessoModeloArtefato: idProcessoModeloArtefato || null,
            dsHash: dsHash || null,
        }, { showLoading: false })

        if (!data?.success || !data.data?.uploadUrl || !data.data?.key) {
            const detalhe = Array.isArray(data?.errors) && data.errors[0] ? data.errors[0] : null
            throw new Error(detalhe || data?.msg || 'Não foi possível gerar a URL de upload.')
        }

        return data.data
    } catch (error) {
        if (error?.message && !error.response) {
            throw error
        }
        const detalhe = error.response?.data?.errors?.[0] || error.response?.data?.msg
        throw new Error(detalhe || 'Não foi possível gerar a URL de upload.')
    }
}

export async function uploadFileToS3(file, options = {}) {
    if (!file) {
        throw new Error('Arquivo inválido.')
    }

    const fileName = options.fileName || file.name
    const contentType = options.contentType || file.type || 'application/octet-stream'
    const { uploadUrl, key, hash, fileName: savedFileName } = await createUploadUrl({
        destino: options.destino,
        fileName,
        contentType,
        size: file.size,
        idProcesso: options.idProcesso,
        idProcessoModeloArtefato: options.idProcessoModeloArtefato,
        dsHash: options.dsHash,
    })

    const uploadResponse = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
            'Content-Type': contentType,
        },
        body: file,
    })

    if (!uploadResponse.ok) {
        throw new Error('Falha ao enviar arquivo para o S3.')
    }

    return {
        key,
        hash,
        fileName: savedFileName || fileName,
    }
}
